<plan-modal>
				<div id="{ props.modalId }" class="modal js-modal">
					<div class="modal__bg js-modal-close"></div>
					<div class="modal__content modal_filter">
						<div class="modal__content_inner">
							<h2 class="modal_title">プラン変更</h2>
							
							<form action="" class="form_filter">
								<template each={item in state.items}>
								<div class="bnr_plan" id="div-{item.id}" onclick="{()=>divClick(item.id)}" style="cursor:pointer">
									<div class="radio_wrap plan">
										<input type="radio" name="plan-select" value="{item.id}" id="plan-{item.id}" class="radio-input" onclick={(e)=>select(e, item.id)}>
										<label for="plan-{item.id}" class="radio_label">{item.name}</label>
                                        <p class="notice" if={!item.immediate}>※このプランの適用は翌月からになります。</p>
									</div><!--/.radio_wrap-->
									
									<dl class="bnr_plan_detail">
										<dt class="bnr_plan_detail-title">月間基本ご利用可能カウント</dt>
										<dd class="bnr_plan_detail-content"><span class="emphasis">{item.tickets.toLocaleString()}</span></dd>
										<dt class="bnr_plan_detail-title">月額</dt>
										<dd class="bnr_plan_detail-content">{item.price.toLocaleString()}円 (税込)</dd>
									</dl>
								</div><!--/.bnr_plan-->
								</template>
							</form><!--/.form_filter	-->   
							
							<button if={state.showButton} class="button button-primary" type="button" value="プランを変更する" onclick="{(e)=>commit(e)}"><a href="#">プランを変更する</a></button>
						</div><!--/.modal__content_inner-->
						<a style="cursor:pointer" class="btn_close_modal js-modal-close" onclick="{ onClose }"><img src="/assets/img/common/icn_close_modal.svg" alt="閉じる"></a>
					</div><!--modal__content-->
				</div><!--modal-->



  <script>
    import di from "dependeny-injection";
    import { api as SettingPlanApi } from "@model/setting-plan.js";

    export default {
        state: {
            items: [],
            showButton: false
        },
        onBeforeMount(){
            SettingPlanApi.on('fetched:items', (data) => {
                this.state.items = data;
                this.update()
            });
            SettingPlanApi.on('committed', (success, data) => {
                if (!success) {
                    alert(data);
                    return;
                }
                this.settingStatusApi.items();
                this.onClose();
                if (data && data.hasOwnProperty('href')) {
                    location.href = data.href;
                }
            });

            this.settingStatusApi = this.props.settingStatusApi;
            this.settingStatusApi.on('plan-modal:shown', () => {
                SettingPlanApi.items();
            });
        },
        select(e, plan_id){
            let divs = this.root.querySelectorAll('div.is-selected');
            if (divs) {
                divs.forEach((element)=>{
                    element.classList.remove('is-selected');
                })
            }
            let target = this.root.querySelector(`#div-${plan_id}`);
            if (target) {
                target.classList.add('is-selected');
            }
            let selected = this.root.querySelector("input[name=plan-select]:checked");
            if (selected) {
                this.state.showButton = true;
                this.update();
            }
        },
        divClick(id){
            let target = this.root.querySelector(`#plan-${id}`);
            if (target) {
                target.click();
            }
            let selected = this.root.querySelector("input[name=plan-select]:checked");
            if (selected) {
                this.state.showButton = true;
                this.update();
            }
        },
        async commit(e) {
            let selected = this.root.querySelector("input[name=plan-select]:checked");
            if (selected && selected.value) {
                this.state.showButton = false;
                this.update();
                const result = await SettingPlanApi.commit(Number(selected.value));
                this.state.showButton = true;
                this.update();
            }
        },
      onClose(e) {
        window.$(this.$(`#${this.props.modalId}`)).fadeOut(100);
      },
    };
  </script>
</plan-modal>